import React, { useEffect } from 'react';
import { useParams, Navigate } from 'react-router-dom';
import { useUser } from 'context/user/User';
import StationPage from 'modules/restaurant/station/StationPage';
import paths from 'routes/paths';

export default function StationApp() {
    const { slug, stationSlug } = useParams();
    const { user, setUser } = useUser();

    const waiterToken = localStorage.getItem('otp_token');
    const waiterUserRaw = localStorage.getItem('otp_user');
    const waiterUser = waiterUserRaw ? JSON.parse(waiterUserRaw) : null;
    const view = waiterUser?.views?.[0];

    // Hydrate UserContext so child components can access establishment info
    useEffect(() => {
        if (waiterUser && !user) {
            setUser(waiterUser);
        }
    }, []);

    if (!waiterToken || !waiterUser) {
        return <Navigate to={paths.otp.login} replace />;
    }

    // Must be a station view
    if (view?.type !== 'station') {
        const userSlug = waiterUser?.establishments?.[0]?.slug;
        return <Navigate to={`/${userSlug}/garcom`} replace />;
    }

    // Validate slug matches establishment
    const userSlug = waiterUser?.establishments?.[0]?.slug;
    if (userSlug && userSlug !== slug) {
        return <Navigate to={`/${userSlug}/estacao/${view.station.slug}`} replace />;
    }

    // Validate stationSlug matches assigned station
    if (view.station.slug !== stationSlug) {
        return <Navigate to={`/${slug}/estacao/${view.station.slug}`} replace />;
    }

    return <StationPage station={view.station} />;
}
